import {
  WidgetType,
  MatchDecorator,
  Decoration,
  ViewPlugin,
  EditorView,
} from "@codemirror/view";

class DateTokenWidget extends WidgetType {
  value;
  label;

  constructor(value, label) {
    super();
    this.value = value;
    this.label = label;
  }

  toDOM() {
    const span = document.createElement("span");

    span.textContent = this.label || this.value;
    span.className = "token-date";
    return span;
  }
}

const createDateTokenExtension = (dateTokens) => {
  const dateTokenMatcher = new MatchDecorator({
    regexp: /{{(date\.([a-zA-Z]+))}}/g,
    decoration: (match) => {
      const token = dateTokens.find((token) => token.value === match[2]);
      if (!token) return null;

      return Decoration.replace({
        widget: new DateTokenWidget(match[2], token.label),
      });
    },
  });

  return ViewPlugin.fromClass(
    class {
      tokens;
      constructor(view) {
        this.tokens = dateTokenMatcher.createDeco(view);
      }
      update(update) {
        this.tokens = dateTokenMatcher.updateDeco(update, this.tokens);
      }
    },
    {
      decorations: (instance) => instance.tokens,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.tokens || Decoration.none;
        }),
    },
  );
};

export default createDateTokenExtension;
